import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-global-error-modal',
    templateUrl: './global-error-modal.component.html',
    styleUrls: ['./global-error-modal.component.scss'],
    standalone: false
})
export class GlobalErrorModalComponent implements OnInit {
  devMode = false;
  details = '';
  config: any = {};
  constructor(
    private dialogRef: MatDialogRef<GlobalErrorModalComponent>,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.config = data;
  }

  ngOnInit(): void {
    this.devMode = this.config.devMode;
    this.details = this.config.details;
  }

  close(): void {
    // using ngZone because of this: https://github.com/angular/components/issues/13640
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }
}
